import "bootstrap/dist/css/bootstrap.min.css";
import { get, ref } from "firebase/database";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../Firebase";

const ParivarCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [searchForm, setSearchForm] = useState({
    identifier: "",
    password: "",
  });
  const [searchError, setSearchError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchForm((prev) => ({ ...prev, [name]: value }));
    setSearchError("");
  };

  const searchFamily = async () => {
    const { identifier, password } = searchForm;

    if (!identifier || !password) {
      setSearchError("ID/Phone/Aadhaar और पासवर्ड दोनों आवश्यक हैं");
      return;
    }

    setLoading(true);
    setSearchError("");

    try {
      // First try direct ID search
      const snap = await get(ref(db, `registration/${identifier}`));
      if (snap.exists()) {
        const family = snap.val();
        if (family.meta?.password !== password) {
          setSearchError("पासवर्ड गलत है");
          setLoading(false);
          return;
        }
        if (family.meta?.status !== "approved") {
          setSearchError("अभी कार्ड approve नहीं हुआ है");
          setLoading(false);
          return;
        }
        setSelectedFamily({ id: identifier, ...family });
        setIsAuthenticated(true);
        setLoading(false);
        return;
      }

      // Search across all registrations by mobile/aadhaar
      const allSnap = await get(ref(db, "registration"));
      if (!allSnap.exists()) {
        setSearchError("कोई डेटा नहीं मिला");
        setLoading(false);
        return;
      }

      const data = allSnap.val();
      let foundFamily = null;

      for (const [id, family] of Object.entries(data)) {
        // Check family mobile or head aadhaar
        const matchesMobile = family.basic?.mobile === identifier;
        const matchesAadhaar = family.basic?.headAadhaar === identifier;

        // Check in members
        let memberMatch = false;
        if (family.members) {
          memberMatch = Object.values(family.members).some(
            (member) =>
              member.mobile === identifier || member.aadhaar === identifier,
          );
        }

        if (matchesMobile || matchesAadhaar || memberMatch) {
          if (family.meta?.password !== password) {
            setSearchError("पासवर्ड गलत है");
            setLoading(false);
            return;
          }
          if (family.meta?.status !== "approved") {
            setSearchError("अभी कार्ड approve नहीं हुआ है");
            setLoading(false);
            return;
          }
          foundFamily = { id, ...family };
          break;
        }
      }

      if (foundFamily) {
        setSelectedFamily(foundFamily);
        setIsAuthenticated(true);
      } else {
        setSearchError("कोई मैचिंग रिकॉर्ड नहीं मिला");
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchError("खोज में त्रुटि हुई");
    } finally {
      setLoading(false);
    }
  };

  const resetSearch = () => {
    setSearchForm({ identifier: "", password: "" });
    setSelectedFamily(null);
    setIsAuthenticated(false);
    setSearchError("");
    navigate("/");
  };

  // Print only card function - front/back design with color strips
  const handlePrintCard = (family) => {
    const printWindow = window.open("", "_blank");
    const members = family.members ? Object.values(family.members) : [];
    const printDate = new Date().toLocaleString("hi-IN");

    const chunks = [];
    for (let i = 0; i < Math.max(1, members.length); i += 4) {
      chunks.push(members.slice(i, i + 4));
    }

    const cardsHTML = chunks
      .map(
        (chunk, cardIndex) => `
      <div class="page">

        <!-- FRONT CARD -->
        <div class="family-card front-card">

          <div class="top-header">
            <div class="logo-box">
              <img src="/Logo.png" />
            </div>
            <div class="title-box">
              <h1>जैन समग्र परिवार कार्ड</h1>
            </div>
            <div class="family-id-box">
              <div class="id-title">परिवार आई. डी.</div>
              <div class="id-value">${family.id || "-"}</div>
              <div class="color-strip">
                <span class="red"></span>
                <span class="yellow"></span>
                <span class="green"></span>
                <span class="blue"></span>
              </div>
            </div>
          </div>

          <div class="main-content">
            <div class="info-grid">
              <div class="field-row">
                <span class="label">परिवार का मुखिया :</span>
                <span class="value">${family.basic?.headName || "-"}</span>
              </div>
              <div class="field-row">
                <span class="label">संपर्क :</span>
                <span class="value">${family.basic?.mobile || "-"}</span>
              </div>
              <div class="field-row full">
                <span class="label">असामी मंदिर का नाम :</span>
                <span class="value">${family.basic?.Mandirtype || "-"}</span>
              </div>
              <div class="field-row full">
                <span class="label">क्षेत्र का प्रकार ग्राम पंचायत :</span>
                <span class="value">${family.basic?.panchayat || "-"}</span>
              </div>
              <div class="field-row">
                <span class="label">राज्य :</span>
                <span class="value">${family.basic?.state || "-"}</span>
              </div>
              <div class="field-row">
                <span class="label">जिला :</span>
                <span class="value">${family.basic?.city || "-"}</span>
              </div>
              <div class="field-row">
                <span class="label">ब्लॉक :</span>
                <span class="value">${family.basic?.block || "-"}</span>
              </div>
              <div class="field-row full">
                <span class="label">परिवार में कुल सदस्य :</span>
                <span class="value">${family.basic?.Totalmember || members.length || "-"}</span>
              </div>
            </div>
          </div>

          <div class="bottom-strip">
            <span class="red"></span>
            <span class="yellow"></span>
            <span class="white"></span>
            <span class="green"></span>
            <span class="blue"></span>
          </div>

        </div>

        <!-- BACK CARD -->
        <div class="family-card back-card">

          <div class="back-title">परिवार के सदस्यों का विवरण</div>

          <table class="member-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>सदस्य आईडी</th>
                <th>सदस्य का नाम</th>
                <th>उम्र</th>
                <th>लिंग</th>
                <th>संबंध</th>
              </tr>
            </thead>
            <tbody>
              ${chunk
                .map(
                  (m, i) => `
                <tr>
                  <td>${cardIndex * 4 + i + 1}</td>
                  <td>${m.memberId || "-"}</td>
                  <td>${m.name || "-"}</td>
                  <td>${m.dob ? calculateAge(m.dob) : "-"}</td>
                  <td>${m.gender === "पुरुष" ? "पु." : m.gender === "महिला" ? "म." : "-"}</td>
                  <td>${m.relation || "-"}</td>
                </tr>
              `,
                )
                .join("")}
            </tbody>
          </table>

          <div class="footer">
            <div>jainsamagra.com</div>
            <div>कार्ड प्रिंट दिनांक : ${printDate}</div>
          </div>

          <div class="bottom-strip">
            <span class="red"></span>
            <span class="yellow"></span>
            <span class="white"></span>
            <span class="green"></span>
            <span class="blue"></span>
          </div>

        </div>

      </div>
    `,
      )
      .join("");

    printWindow.document.write(`
      <html>
        <head>
          <title>Family Card</title>
          <style>
            *{ margin:0; padding:0; box-sizing:border-box; }
            /* prefer exact colors when printing */
            * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            body{ font-family:serif; background:#f2f2f2; padding:20px; }
            @page{ size:A4 portrait; margin:10mm; }
            @media print{
              /* reinforce color printing in print media */
              * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              body{ background:white; padding:0; }
              .page{ page-break-after:always; }
            }
            .page{ width:100%; margin-bottom:30px; }
            .family-card{
              width:100%; border-radius:25px; overflow:hidden;
              background:#f4e1c4; /* solid fallback for printers */
              border:2px solid #d2b48c;
              margin-bottom:20px; position:relative;
            }
            .front-card{
              /* keep a solid background-color (printers often skip images)
                 then provide decorative images via background-image */
              background-color: #f4e1c4;
              background-image: linear-gradient(rgba(248,236,210,.96), rgba(248,236,210,.96)), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Cpath fill='%23f2e4c9' d='M20 120C40 80 80 40 120 30C150 20 170 30 180 50C155 55 125 70 110 90C95 110 80 140 60 150C30 160 15 150 20 120Z'/%3E%3Cpath fill='%23e8d3b3' d='M60 140C80 100 110 80 140 70C160 60 180 70 185 90C150 100 130 120 110 140C90 160 70 170 60 140Z'/%3E%3C/svg%3E");
              background-position: center;
              background-size: 450px;
              background-repeat: no-repeat;
              min-height:380px;
            }
            .top-header{ display:flex; justify-content:space-between; align-items:flex-start; padding:20px 25px; }
            .logo-box img{ width:95px; height:95px; object-fit:contain; }
            .title-box{ flex:1; text-align:center; padding-top:10px; }
            .title-box h1{ font-size:48px; color:#7a0d0d; text-shadow:2px 2px 0px #fff; font-weight:bold; }
            .family-id-box{ width:180px; background:#fff; border-bottom:6px solid #c40000; box-shadow:0 2px 8px rgba(0,0,0,.2); }
            .id-title{ background:#e8d3b5; color:#6b0000; font-weight:bold; text-align:center; padding:8px; font-size:20px; }
            .id-value{ text-align:center; font-size:26px; font-weight:bold; padding:20px 10px; color:#222; }
            .color-strip{ display:flex; height:8px; }
            .color-strip span{ flex:1; }
            .red{ background:#c40000; }
            .yellow{ background:#ffe600; }
            .green{ background:#008d36; }
            .blue{ background:#001fb5; }
            .white{ background:#ffffff; }
            .main-content{ padding:10px 55px 40px; }
            .info-grid{
              background:rgba(255,255,255,.55); border-radius:40px; padding:40px;
              min-height:230px; display:grid; grid-template-columns:1fr 1fr; gap:28px 40px;
            }
            .field-row{ display:flex; flex-direction:column; gap:0.45rem; }
            .field-row.full{ grid-column:1 / span 2; }
            .label{ font-size:24px; font-weight:bold; margin-bottom:10px; color:#111; }
            .value{ border-bottom:2px dashed #777; padding-bottom:6px; font-size:20px; color:#222; }
            .bottom-strip{ height:12px; display:flex; }
            .bottom-strip span{ flex:1; }
            .back-card{
              padding:30px;
              background:
                linear-gradient(135deg, #f6e7cd 0%, #edd5b2 100%),
                radial-gradient(circle at 15% 15%, rgba(255,255,255,0.7) 0, rgba(255,255,255,0) 20%),
                radial-gradient(circle at 85% 85%, rgba(255,255,255,0.5) 0, rgba(255,255,255,0) 15%);
              background-blend-mode: screen, normal, normal;
            }
            .back-title{
              width:420px; margin:0 auto 25px; background:#7a0d0d; color:white;
              text-align:center; padding:12px; border-radius:30px; font-size:28px; font-weight:bold;
            }
            .member-table{ width:100%; border-collapse:collapse; font-size:20px; }
            .member-table th{ background:#f0e2c6; color:#5a0000; padding:14px; border:1px solid #c9b08c; }
            .member-table td{ padding:14px; border:1px solid #d4c2a3; text-align:center; }
            .member-table tr:nth-child(even){ background:#fff7e7; }
            .footer{ display:flex; justify-content:space-between; margin-top:25px; font-size:18px; color:#333; }
          </style>
        </head>
        <body>
          ${cardsHTML}
          <script>window.onload = function(){ window.print(); };<\/script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Print complete details function
  const handlePrintComplete = (family) => {
    const printWindow = window.open("", "_blank");
    const members = family.members ? Object.values(family.members) : [];
    const printDate = new Date().toLocaleString("hi-IN");
    const regDate = family.meta?.createdAt
      ? new Date(family.meta.createdAt).toLocaleDateString("hi-IN")
      : family.basic?.createdAt
        ? new Date(family.basic.createdAt).toLocaleDateString("hi-IN")
        : "-";
    const address = [
      family.basic?.address,
      family.basic?.urbanArea,
      family.basic?.gram,
      family.basic?.panchayat,
      family.basic?.block,
      family.basic?.city,
      family.basic?.state,
      family.basic?.country,
    ].filter(Boolean).join(", ");

    const memberRows = members.map((m, i) => `
      <tr>
        <td style="text-align:center;padding:6px 4px;border:1px solid #ccc;font-size:11px;">${i + 1}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.memberId || "NA"}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;font-weight:600;">${m.name || "NA"}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.fatherName || "NA"}</td>
        <td style="text-align:center;padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.gender === "पुरुष" ? "पु." : m.gender === "महिला" ? "म." : m.gender || "NA"}</td>
        <td style="text-align:center;padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.dob ? calculateAge(m.dob) : "NA"}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.relation || "NA"}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.maritalStatus || "NA"}</td>
        <td style="padding:6px 4px;border:1px solid #ccc;font-size:11px;">${m.mobile || "NA"}</td>
      </tr>
    `).join("");

    const row = (label, value) => `
      <div style="display:flex;align-items:baseline;margin-bottom:8px;">
        <span style="min-width:220px;font-weight:700;font-size:12px;color:#111;flex-shrink:0;">${label} :</span>
        <span style="flex:1;font-size:12px;color:#222;border-bottom:1px dotted #999;padding-bottom:2px;padding-left:8px;">${value || "-"}</span>
      </div>`;

    printWindow.document.write(`<!DOCTYPE html><html><head>
      <meta charset="UTF-8">
      <title>जैन समाज परिवार विवरण - ${family.basic?.headName || ""}</title>
      <style>
        @page { size: A4 portrait; margin: 12mm 14mm; }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: Arial, Helvetica, sans-serif; background: #f0f0f0; color: #000; }
        .page {
          width: 794px;
          background: #fff;
          margin: 0 auto;
          padding: 20px 36px 24px;
        }
        /* HEADER */
        .hdr { display:flex; align-items:center; justify-content:space-between; margin-bottom:10px; }
        .hdr-logo { width:72px; height:72px; border-radius:50%; object-fit:contain; border:2px solid #7b0000; }
        .hdr-text { text-align:center; flex:1; padding:0 16px; }
        .hdr-t1 { font-size:20px; font-weight:800; color:#7b0000; letter-spacing:0.5px; }
        .hdr-t2 { font-size:13px; font-weight:700; color:#333; margin-top:3px; }
        .hdr-t3 { font-size:12px; font-weight:600; color:#7b0000; margin-top:2px; }
        .divider { height:3px; background:#7b0000; margin:10px 0 16px; border-radius:2px; }
        /* SECTION HEADING */
        .sec-head {
          background:#f0f0f0; color:#111;
          font-size:12px; font-weight:800;
          padding:5px 10px; margin:14px 0 10px;
          border-left:4px solid #7b0000;
          letter-spacing:0.3px;
        }
        /* TWO-COL INFO GRID */
        .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:0 24px; margin-bottom:4px; }
        .info-full { grid-column: 1 / span 2; }
        .info-row { display:flex; align-items:baseline; margin-bottom:7px; }
        .info-lbl { min-width:160px; font-weight:700; font-size:11px; color:#111; flex-shrink:0; }
        .info-val { flex:1; font-size:11px; color:#222; border-bottom:1px dotted #aaa; padding-bottom:1px; padding-left:6px; }
        /* ADDRESS BOX */
        .addr-box {
          border:1px solid #ccc; border-radius:4px;
          background:#fff; padding:8px 12px;
          font-size:11.5px; line-height:1.6;
          margin-bottom:4px;
        }
        /* MEMBERS TABLE */
        .mem-table { width:100%; border-collapse:collapse; font-size:10.5px; margin-top:4px; }
        .mem-table th {
          background:#7b0000; color:#fff;
          padding:6px 4px; text-align:center;
          border:1px solid #7b0000;
          font-size:10.5px; font-weight:700;
        }
        .mem-table td { padding:5px 4px; border:1px solid #ccc; font-size:10.5px; vertical-align:middle; }
        .mem-table tr:nth-child(even) td { background:#fafafa; }
        /* SIGNATURE - removed */
        /* FOOTER */
        .ftr { display:flex; justify-content:space-between; margin-top:16px; padding-top:8px; border-top:1px solid #ccc; font-size:11px; color:#555; font-weight:600; }
        /* AUTO PAGE BREAK */
        .mem-table { page-break-inside: auto; }
        .mem-table tr { page-break-inside: avoid; page-break-after: auto; }
        .page { min-height: auto; }
        @media print {
          body { background:#fff; }
          .no-print { display:none !important; }
          .page { margin:0; padding:20px 28px; box-shadow:none; }
          * { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
        }
      </style>
    </head><body>

    <div style="text-align:right;padding:10px 16px;" class="no-print">
      <button onclick="window.print()" style="background:#7b0000;color:#fff;border:none;padding:8px 22px;font-size:13px;font-weight:700;border-radius:5px;cursor:pointer;">🖨️ प्रिंट करें</button>
    </div>

    <div class="page">

      <!-- HEADER -->
      <div class="hdr">
        <img src="/exp.png" class="hdr-logo" onerror="this.src='/Logo.png'" alt="logo">
        <div class="hdr-text">
          <div class="hdr-t1">जैन समाज पोर्टल</div>
          <div class="hdr-t2">जैन समग्र फाउन्डेशन द्वारा संचालित</div>
          <div class="hdr-t3">जैन समाज परिवार विवरण रिपोर्ट</div>
        </div>
        <img src="/colgo.png" class="hdr-logo" onerror="this.src='/Logo.png'" alt="logo">
      </div>
      <div class="divider"></div>

      <!-- FAMILY BASIC INFO -->
      <div class="sec-head">परिवार की मूल जानकारी</div>
      <div class="info-grid">
        <div class="info-row"><span class="info-lbl">परिवार आईडी</span><span class="info-val">${family.id || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">परिवार के मुखिया</span><span class="info-val">${family.basic?.headName || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">मोबाइल नंबर</span><span class="info-val">${family.basic?.mobile || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">समाज में प्रचलित नाम</span><span class="info-val">${family.basic?.displayName || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">कुल सदस्य</span><span class="info-val">${family.basic?.Totalmember || members.length || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">पंजीयन दिनांक</span><span class="info-val">${regDate}</span></div>
        <div class="info-row"><span class="info-lbl">देश</span><span class="info-val">${family.basic?.country || "भारत"}</span></div>
        <div class="info-row"><span class="info-lbl">राज्य</span><span class="info-val">${family.basic?.state || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">जिला</span><span class="info-val">${family.basic?.city || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">ब्लॉक</span><span class="info-val">${family.basic?.block || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">ग्राम पंचायत</span><span class="info-val">${family.basic?.panchayat || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">ग्राम / शहर</span><span class="info-val">${family.basic?.gram || family.basic?.urbanArea || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">जाति प्रकार</span><span class="info-val">${family.basic?.jatiPrakar || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">उपजाति प्रकार</span><span class="info-val">${family.basic?.upjatiPrakar || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">गोत्र / वंश</span><span class="info-val">${family.basic?.gotra || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">मूर</span><span class="info-val">${family.basic?.moor || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">परिवार स्थिति</span><span class="info-val">${family.basic?.familyType || "NA"}</span></div>
        <div class="info-row"><span class="info-lbl">आवास स्थिति</span><span class="info-val">${family.basic?.houseType || "NA"}</span></div>
      </div>

      <!-- ADDRESS -->
      <div class="sec-head">पता विवरण</div>
      <div class="addr-box">${address || "NA"}</div>

      <!-- TEMPLE -->
      <div class="sec-head">जैन मंदिर जानकारी</div>
      <div class="info-grid">
        <div class="info-row info-full"><span class="info-lbl">संबंधित जैन मंदिर</span><span class="info-val">${family.basic?.Mandirtype || "NA"}</span></div>
      </div>

      <!-- MEMBERS TABLE -->
      <div class="sec-head">परिवार के सदस्यों की जानकारी</div>
      <table class="mem-table">
        <thead>
          <tr>
            <th style="width:4%">क्र.</th>
            <th style="width:10%">सदस्य ID</th>
            <th style="width:18%">नाम</th>
            <th style="width:14%">पिता/पति</th>
            <th style="width:6%">लिंग</th>
            <th style="width:6%">उम्र</th>
            <th style="width:10%">संबंध</th>
            <th style="width:12%">वैवाहिक स्थिति</th>
            <th style="width:14%">मोबाइल</th>
          </tr>
        </thead>
        <tbody>${memberRows}</tbody>
      </table>

      <!-- FOOTER -->
      <div class="ftr">
        <span>&#128197; प्रिंट दिनांक : ${printDate}</span>
        <span>&#127760; jainsamagra.com</span>
      </div>

    </div>
    <script>window.onload = function(){ window.print(); };<\/script>
    </body></html>`);
    printWindow.document.close();
  };

  const calculateAge = (dob) => {
    if (!dob) return "";
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  return (
    <div
      className="container-fluid py-3 py-md-5 px-2 px-md-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <div className="container">
        {/* Header */}
        <div className="row mb-3 mb-md-4">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body text-center py-3 py-md-4">
                <h2
                  className="card-title text-primary mb-2 mb-md-3"
                  style={{
                    fontSize: "1.5rem",
                    fontSize: "clamp(1.2rem, 4vw, 1.8rem)",
                  }}
                >
                  🏷️ जैन समग्र परिवार कार्ड डाउनलोड करें
                </h2>
                <p
                  className="text-muted mb-0"
                  style={{
                    fontSize: "0.9rem",
                    fontSize: "clamp(0.8rem, 3vw, 1rem)",
                  }}
                >
                  डिजिटल परिवार कार्ड को मोबाइल या कंप्यूटर में सेव करें।
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Secure Search Form */}
        {!isAuthenticated && (
          <div className="row mb-3 mb-md-4">
            <div className="col-12 col-lg-8 col-xl-6 mx-auto">
              <div className="card shadow">
                <div className="card-header bg-warning text-dark text-center py-2 py-md-3">
                  <h5
                    className="mb-0"
                    style={{
                      fontSize: "1rem",
                      fontSize: "clamp(0.9rem, 3vw, 1.1rem)",
                    }}
                  >
                    🔒 सुरक्षित खोज - केवल अनुमोदित कार्ड
                  </h5>
                </div>
                <div className="card-body p-3 p-md-4">
                  <div className="row g-3">
                    <div className="col-12">
                      <label
                        className="form-label fw-semibold"
                        style={{ fontSize: "0.9rem" }}
                      >
                        परिवार ID / मोबाइल / आधार *
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="identifier"
                        value={searchForm.identifier}
                        onChange={handleInputChange}
                        placeholder="परिवार ID या मोबाइल या आधार नंबर दर्ज करें"
                        style={{ fontSize: "16px" }}
                      />
                    </div>
                    <div className="col-12">
                      <label
                        className="form-label fw-semibold"
                        style={{ fontSize: "0.9rem" }}
                      >
                        पासवर्ड *
                      </label>
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        name="password"
                        value={searchForm.password}
                        onChange={handleInputChange}
                        placeholder="पंजीकरण के समय बनाया गया पासवर्ड"
                        style={{ fontSize: "16px" }}
                      />
                    </div>
                  </div>

                  {searchError && (
                    <div
                      className="alert alert-danger mt-3 mb-0"
                      style={{ fontSize: "0.9rem" }}
                    >
                      ❌ {searchError}
                    </div>
                  )}

                  <div
                    className="text-muted small mb-3"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <strong>नोट:</strong> एक फील्ड (ID या Mobile या Aadhaar) और
                    पासवर्ड भरना आवश्यक है
                  </div>

                  <div className="d-grid mt-3">
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={searchFamily}
                      disabled={loading}
                      style={{ fontSize: "1rem", minHeight: "48px" }}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          खोज रहे हैं...
                        </>
                      ) : (
                        "🔍 अनुमोदित परिवार कार्ड खोजें"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Two Options Display */}
        {isAuthenticated && selectedFamily && (
          <div className="row mb-3 mb-md-4">
            <div className="col-12">
              <div className="card shadow-lg border-0">
                <div
                  className="card-header"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                  }}
                >
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
                    <h4
                      className="mb-0 mb-sm-0"
                      style={{
                        fontSize: "1.1rem",
                        fontSize: "clamp(1rem, 3vw, 1.2rem)",
                      }}
                    >
                      📋 परिवार कार्ड विकल्प
                    </h4>
                    <button
                      className="btn btn-warning btn-sm px-3 py-2"
                      onClick={resetSearch}
                      style={{ fontSize: "0.85rem" }}
                    >
                      🔄 नई खोज
                    </button>
                  </div>
                </div>
                <div className="card-body p-3 p-md-4">
                  {/* Three Main Options */}
                  <div className="row g-3 g-md-4 mb-3 mb-md-4">
                    {/* Option 1: View Complete Details */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div
                        className="card h-100 border-0 shadow"
                        style={{
                          background:
                            "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                        }}
                      >
                        <div className="card-body text-center p-3 p-md-4">
                          <div
                            className="mb-2 mb-md-3"
                            style={{
                              fontSize: "2rem",
                              fontSize: "clamp(1.8rem, 6vw, 2.5rem)",
                            }}
                          >
                            🖨️
                          </div>
                          <h5
                            className="card-title text-primary mb-2 mb-md-3"
                            style={{
                              fontSize: "1rem",
                              fontSize: "clamp(0.9rem, 3vw, 1.1rem)",
                            }}
                          >
                            पूरी जानकारी प्रिंट करें
                          </h5>
                          <p
                            className="card-text text-muted mb-3 mb-md-4"
                            style={{
                              fontSize: "0.85rem",
                              fontSize: "clamp(0.8rem, 2.5vw, 0.9rem)",
                            }}
                          >
                            परिवार की सभी जानकारी और सदस्यों का पूरा विवरण A4
                            में प्रिंट करें
                          </p>
                          <button
                            className="btn btn-primary w-100"
                            onClick={() => handlePrintComplete(selectedFamily)}
                            style={{
                              background:
                                "linear-gradient(135deg, #2196f3 0%, #1976d2 100%)",
                              border: "none",
                              minHeight: "44px",
                              fontSize: "0.9rem",
                            }}
                          >
                            🖨️ पूरी जानकारी प्रिंट करें
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Option 2: Print Card Only */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div
                        className="card h-100 border-0 shadow"
                        style={{
                          background:
                            "linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)",
                        }}
                      >
                        <div className="card-body text-center p-3 p-md-4">
                          <div
                            className="mb-2 mb-md-3"
                            style={{
                              fontSize: "2rem",
                              fontSize: "clamp(1.8rem, 6vw, 2.5rem)",
                            }}
                          >
                            🎫
                          </div>
                          <h5
                            className="card-title text-success mb-2 mb-md-3"
                            style={{
                              fontSize: "1rem",
                              fontSize: "clamp(0.9rem, 3vw, 1.1rem)",
                            }}
                          >
                            सिर्फ कार्ड प्रिंट
                          </h5>
                          <p
                            className="card-text text-muted mb-3 mb-md-4"
                            style={{
                              fontSize: "0.85rem",
                              fontSize: "clamp(0.8rem, 2.5vw, 0.9rem)",
                            }}
                          >
                            केवल डिजिटल परिवार कार्ड प्रिंट करें - एक पेज में दो
                            कार्ड (आगे और पीछे)
                          </p>
                          <button
                            className="btn btn-success w-100"
                            onClick={() => {
                              localStorage.setItem(
                                "parivarCardData",
                                JSON.stringify(selectedFamily),
                              );
                              window.open(
                                "/parivar-card-layout?autoprint=1",
                                "_blank",
                              );
                            }}
                            style={{
                              background:
                                "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                              border: "none",
                              minHeight: "44px",
                              fontSize: "0.9rem",
                            }}
                          >
                            🎫 सिर्फ कार्ड प्रिंट
                          </button>
                          <div className="mt-2"></div>
                        </div>
                      </div>
                    </div>

                    {/* Option 3: Print Complete Details */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div
                        className="card h-100 border-0 shadow"
                        style={{
                          background:
                            "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                        }}
                      >
                        <div className="card-body text-center p-3 p-md-4">
                          <div
                            className="mb-2 mb-md-3"
                            style={{
                              fontSize: "2rem",
                              fontSize: "clamp(1.8rem, 6vw, 2.5rem)",
                            }}
                          >
                            🖨️
                          </div>
                          <h5
                            className="card-title text-warning mb-2 mb-md-3"
                            style={{
                              fontSize: "1rem",
                              fontSize: "clamp(0.9rem, 3vw, 1.1rem)",
                            }}
                          >
                            संपूर्ण विवरण प्रिंट
                          </h5>
                          <p
                            className="card-text text-muted mb-3 mb-md-4"
                            style={{
                              fontSize: "0.85rem",
                              fontSize: "clamp(0.8rem, 2.5vw, 0.9rem)",
                            }}
                          >
                            परिवार की सभी जानकारी A to Z प्रिंट करें (पासवर्ड
                            छोड़कर)
                          </p>
                          <button
                            className="btn btn-warning w-100"
                            onClick={() => handlePrintComplete(selectedFamily)}
                            style={{
                              background:
                                "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                              border: "none",
                              color: "white",
                              minHeight: "44px",
                              fontSize: "0.9rem",
                            }}
                          >
                            📋 संपूर्ण प्रिंट
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Quick Family Info Summary */}
                  <div
                    className="card border-0"
                    style={{
                      background:
                        "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                    }}
                  >
                    <div className="card-body p-3">
                      <h6 className="text-center mb-3 text-warning">
                        📊 परिवार की संक्षिप्त जानकारी
                      </h6>
                      <div className="row text-center">
                        <div className="col-md-3">
                          <div className="fw-bold text-primary">
                            {selectedFamily.basic?.headName || "N/A"}
                          </div>
                          <small className="text-muted">मुखिया</small>
                        </div>
                        <div className="col-md-3">
                          <div className="fw-bold text-success">
                            {selectedFamily.basic?.Totalmember ||
                              (selectedFamily.members
                                ? Object.keys(selectedFamily.members).length
                                : 0)}
                          </div>
                          <small className="text-muted">कुल सदस्य</small>
                        </div>
                        <div className="col-md-3">
                          <div className="fw-bold text-info">
                            {selectedFamily.basic?.city || "N/A"}
                          </div>
                          <small className="text-muted">जिला</small>
                        </div>
                        <div className="col-md-3">
                          <div className="fw-bold text-warning">
                            {selectedFamily.id || "N/A"}
                          </div>
                          <small className="text-muted">परिवार ID</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParivarCard;
